import { ReactComponent as Transgender } from 'assets/icons/transgender.svg';
import { ReactComponent as Female } from 'assets/icons/female.svg';
import { ReactComponent as Male } from 'assets/icons/male.svg';

export default function defineSex(value) {
  let icon;
  switch (value?.toLowerCase()) {
    case 'male':
      icon = <Male />;
      break;
    case 'female':
      icon = <Female />;
      break;
    case 'other':
      icon = <Transgender />;
      break;
    default:
      icon = <Male />;
  }
  return icon;
}
